import { render, staticRenderFns } from "./A7Aplicacao.vue?vue&type=template&id=6b50943b&scoped=true&"
import script from "./A7Aplicacao.vue?vue&type=script&lang=js&"
export * from "./A7Aplicacao.vue?vue&type=script&lang=js&"
import style0 from "./A7Aplicacao.vue?vue&type=style&index=0&id=6b50943b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b50943b",
  null
  
)

export default component.exports